import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import noScroll from 'no-scroll';
import {
	Wrapper,
	HiddenCheck,
	Close,
	CloseIcon,
	Flex,
	Header,
	Body,
	Footer,
} from './fullMobileOverlayStyles';

class FullMobileOverlay extends PureComponent {
	state = {
		interactive: false,
	}

	unfreezeBody = () => {
		noScroll.off();
	}

	handleChange = () => {
		this.setState({ interactive: true });
	}

	render() {
		const { interactive } = this.state;
		const {
			children,
			header,
			footer,
			triggerId,
			darkFooter,
			headerBorder,
		} = this.props;
		if (!interactive) {
			// We lazy render this so it renders only the checkbox with attached listener
			// when the triggerId element is pressed & hidden check changes
			// then handleChange sets state.interactive so the full component renders
			// "open" state is managed via CSS.
			// Why? This helps avoid excessive DOM size: web.dev/dom-size
			return (
				<HiddenCheck id={triggerId} onChange={this.handleChange} />
			);
		}
		return (
			<Fragment>
				<HiddenCheck id={triggerId} />
				<Wrapper>
					<Flex>
						<Header showBorder={headerBorder}>
							{header}
							<Close htmlFor={triggerId} onClick={this.unfreezeBody}>
								<CloseIcon width={21} height={21} />
							</Close>
						</Header>

						<Body>
							{children}
						</Body>

						{footer && (
							<Footer darkFooter={darkFooter}>{footer}</Footer>
						)}
					</Flex>
				</Wrapper>
			</Fragment>
		);
	}

	static propTypes = {
		triggerId: PropTypes.string,
		children: PropTypes.node.isRequired,
		header: PropTypes.node.isRequired,
		footer: PropTypes.node,
		headerBorder: PropTypes.bool,
		darkFooter: PropTypes.bool,
	};

	static defaultProps = {
		triggerId: 'fmo-trigger',
	};
}

export default FullMobileOverlay;
